import { render, staticRenderFns } from "./QuickActionsInstitution.vue?vue&type=template&id=6663a7df"
import script from "./QuickActionsInstitution.vue?vue&type=script&lang=js"
export * from "./QuickActionsInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports